var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "#-icons-/-desktop-3-gray",
    transform: "translate(-12.000000, -12.000000)",
    fill: "#292F41",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.890625,12 L14.109375,12 C12.9462656,12 12,12.9462656 12,14.109375 L12,29.671875 C12,30.8349844 12.9462656,31.7765625 14.109375,31.7765625 L21.8454844,31.7765625 C21.729375,32.8060312 21.4072031,34.0828125 21.1022344,34.3877813 L20.8962656,34.59375 L18.375,34.59375 C17.9866875,34.59375 17.671875,34.9085625 17.671875,35.296875 C17.671875,35.6851875 17.9866875,36 18.375,36 L29.625,36 C30.0133125,36 30.328125,35.6851875 30.328125,35.296875 C30.328125,34.9085625 30.0133125,34.59375 29.625,34.59375 L27.1037344,34.59375 L26.8977656,34.3878281 C26.5927969,34.0828125 26.270625,32.8107188 26.1545156,31.78125 L33.890625,31.78125 C35.0537344,31.78125 36,30.8349844 36,29.671875 L36,14.109375 C36,12.9462656 35.0537344,12 33.890625,12 Z M22.5968906,34.59375 C22.9730625,33.74025 23.1707344,32.569875 23.2516875,31.78125 L24.7483125,31.78125 C24.8292656,32.569875 25.0269844,33.74025 25.4031094,34.59375 L22.5968906,34.59375 Z M34.59375,29.671875 C34.59375,30.0595781 34.2783281,30.375 33.890625,30.375 L24,30.375 L14.109375,30.375 C13.7216719,30.375 13.40625,30.0595781 13.40625,29.671875 L13.40625,28.96875 L23.296875,28.96875 L23.296875,29.671875 C23.296875,30.0601875 23.6116875,30.375 24,30.375 C24.3883125,30.375 24.703125,30.0601875 24.703125,29.671875 L24.703125,28.96875 L34.59375,28.96875 L34.59375,29.671875 Z M34.59375,27.5625 L13.40625,27.5625 L13.40625,14.109375 C13.40625,13.7216719 13.7216719,13.40625 14.109375,13.40625 L33.890625,13.40625 C34.2783281,13.40625 34.59375,13.7216719 34.59375,14.109375 L34.59375,27.5625 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.8302e24694629dc5a4a2ab500f346303.svg";
export { ForwardRef as ReactComponent };